module.exports = __webpack_public_path__ + "img/02-Eisai-เข้าสู่ระบบ.ccb31343.png";